import React, { useEffect, useState } from 'react';
import { Grid, Box, TextField, Autocomplete } from '@mui/material';

// COMPONENTES
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import ModalDetalles from './modales/ModalDetalles';

const Historial = ({ eventos }) => {

    const [unidades, setUnidades] = useState([]);
    const [newEvents, setNewEvents] = useState([]);
    const [unidadSeleccionada, setUnidadSeleccionada] = useState(null);

    const catalogoColores = {

        'HIGH': 'red',
        'MEDIUM': 'orange',
        'LOW': 'blue',

    }

    // =========================================
    // COLUMNAS
    // =========================================

    const columns = [

        { 
            field: 'vehicle', 
            headerName: 'Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'event_type', 
            headerName: 'Incidencia',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'driver', 
            headerName: 'Conductor',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'location', 
            headerName: 'Locacion',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'motivo_retraso', 
            headerName: 'Motivo',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.motivo_retraso || 'PENDIENTE'
        },
        { 
            field: 'severity', 
            headerName: 'Prioridad',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => 
                <Box
                    sx={{
                        color: 'white',
                        backgroundColor: params.row.severity !== null ? catalogoColores[params.row.severity] : 'grey',
                    }}
                >
                    {params.row.severity !== null ? params.row.severity : 'PENDIENTE'}
                </Box>
        },
        { 
            field: 'fecha_evento', 
            headerName: 'Inicio',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'duracion', 
            headerName: 'Response Time',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'fecha_cierre', 
            headerName: 'Fin',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'usuario_label', 
            headerName: 'Atendio',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },

    ];
    
    // =========================================
    // FUNCION PARA MOSTRAR INFO
    // =========================================

    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState({});

    const handleDoubleClick = ( params ) => {

        setSelected(params.row);

        setShowModal(true);

    }

    // =========================================
    // FUNCION PARA CAMBIO DE AUTOCOMPLETE
    // =========================================

    const handleChange = (event, newValue) => {

        if(newValue !== null){

            setUnidadSeleccionada(newValue);
            filtrarEventosPorUnidad(newValue);

        } else {

            setUnidadSeleccionada(null);
            setNewEvents(eventos);

        }

    }

    useEffect(() => {

        setUnidades([...new Set(eventos.map(evento => evento.vehicle))]);

        if(unidadSeleccionada !== null){

            filtrarEventosPorUnidad(unidadSeleccionada);

        } else {

            setNewEvents(eventos);

        }

    },[eventos]);

    // =========================================
    // FUNCION PARA FILTRAR EVENTOS POR UNIDAD
    // =========================================

    const filtrarEventosPorUnidad = (unidad) => {

        const eventosFiltrados = eventos.filter(evento => evento.vehicle === unidad);

        setNewEvents(eventosFiltrados);

    }

    // =========================================

    return (

        <Grid container>

            <Grid size={12}>

                <Autocomplete
                    disablePortal
                    options={unidades}
                    sx={{ width: 300, marginBottom: 2 }}
                    onChange={handleChange}
                    renderInput={(params) => <TextField {...params} label="Unidad" />}
                />

            </Grid>

            <Grid size={12}>

                <MiTabla
                    columns={columns}
                    onRowDoubleClick={handleDoubleClick}
                    data={newEvents}

                />

            </Grid>

            {/* MODAL DETALLES */}

            <ModalDetalles
                open={showModal}
                onClose={() => setShowModal(false)}
                data={selected}
            />

        </Grid>

    )

}

export default Historial